import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { LettersService } from "./letters.service";
import { LetterDetailComponent } from './letter-detail/letter-detail.component';
import { LetterDetailWrapperComponent } from './letter-detail-wrapper/letter-detail-wrapper.component';
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { MailListComponent } from './mail-list/mail-list.component';
import { SystemNotificationService } from "../notifications/system-notifications/services/system-notification.service";
import { LunaCommonModule } from "../common/common.module";

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        LunaCommonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        AgGridModule,
        NgxExtendedPdfViewerModule
    ],
    providers: [
        LettersService,
        SystemNotificationService
  ],
  declarations: [LetterDetailComponent, LetterDetailWrapperComponent, MailListComponent]
})
export class LettersModule { }
